<app-loader></app-loader>
<!-- {{ message | async | json }} -->
<!-- {{ token | async | json }} -->
<div *ngIf="userCommonService?.isMetadataLoaded" class="col-12 device-height web-fixed">
  <app-header *ngIf="notificationService.canFetchNotification" class="top-nav grid header-panel"></app-header>
  <div class="main-panel grid">

    <app-sidebar *ngIf="notificationService.canFetchNotification" class="sidebar left-panel sidebar-scroll">
    </app-sidebar>

    <div class="right-panel" [ngClass]="{'dashboard-page': isDashboardPage}">
      <!-- <app-page-header *ngIf="notificationService.canFetchNotification"></app-page-header> -->

      <div class="web-right-pad right-panel-scroll">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>
<p-toast key="commonToast"></p-toast>
<p-toast key="serviceDownToast" position="top-center" styleClass="service-down-toast-container"></p-toast>